import React from 'react';
import { useHistory } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import './css/Profile.css';

function Profile() {
  const getEmail = localStorage.getItem('user');
  const userEmail = JSON.parse(getEmail) || [];
  const history = useHistory();

  function handleClickDoneRecipes() {
    history.push('/done-recipes');
  }

  function handleClickFavoriteRecipes() {
    history.push('/favorite-recipes');
  }

  function handleClickLogout() {
    localStorage.clear();
    history.push('/');
  }

  return (
    <div className="profile-page">
      <Header Title="Profile" />
      <div className="profile-content">
        <h2 className="" data-testid="profile-email">
          {userEmail.email}
        </h2>
        <button
          data-testid="profile-done-btn"
          type="button"
          onClick={ handleClickDoneRecipes }
        >
          Done Recipes
        </button>
        <br />
        <button
          type="button"
          data-testid="profile-favorite-btn"
          onClick={ handleClickFavoriteRecipes }
        >
          Favorite Recipes
        </button>
        <br />
        <button
          data-testid="profile-logout-btn"
          type="button"
          onClick={ handleClickLogout }
        >
          Logout
        </button>
      </div>
      <Footer />
    </div>
  );
}

export default Profile;
